<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="container content-wrap">
      <div
        class="row"
        v-if="
          recentTransactions &&
            recentTransactions.response &&
            recentTransactions.response.length > 0
        "
      >
        <section>
          <div class="offers" v-for="(item, index) in recentTransactions.response" :key="index">
            <div class="item-info-card-header" v-if="!cardHeader">
              <img
                src="/static/images/calendar.svg"
                alt="Operator"
                class="item-info-card-header__image"
              />
              <div class="item-info-card-header__text">
                <p class="item-info-card-header__text__title">{{ item.description }}</p>
              </div>
            </div>
            <StatementItem
              v-for="(itemSub, index) in item.transactions"
              :key="index"
              :item="itemSub"
            />
          </div>
        </section>
      </div>
      <EplNewStatementEmpty v-else />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import StatementItem from "./StatementItem/index";
import EplNewStatementEmpty from "../components/EplNewStatementEmpty";
export default {
  name: "EplNewTransaction",
  data() {
    return {
      recent_txn_params: {
        start: 0,
        count: 10
      },
      pages_loaded: 0,
      recentTxnsLoaded: false
      //transactionCount:5
    };
  },
  components: { StatementItem, EplNewStatementEmpty },
  props: ["txnCount", "cardHeader"],
  computed: {
    ...mapGetters(["loggedIn", "recentTransactions", "totalTransactionCount"])
  },
  mounted() {
    // console.log(txnCount);
    this.scroll();
    this.loadRecentTransactions(false);
    if (!this.txnCount) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "SCREEN",
        propertyName: "SCREEN_NAME",
        propertyValue: "MY_STATEMENT"
      });
    }
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          !this.txnCount &&
          this.totalTransactionCount.response > this.recent_txn_params.count
        ) {
          this.recent_txn_params.start = this.recent_txn_params.count;
          this.recent_txn_params.start =
            this.recent_txn_params.start +
            this.recent_txn_params.count * this.pages_loaded;

          this.pages_loaded++;
          this.loadRecentTransactions(true);
        }
      };
    },
    loadRecentTransactions(append) {
      if (this.txnCount) {
        this.recent_txn_params.count = this.txnCount;
      }
      var query = this.recent_txn_params;
      if (append) {
        query = {
          params: this.recent_txn_params,
          append
        };
      }
      this.$store.dispatch("recentTransactions", query).then(resp => {
        this.recentTxnsLoaded = true;
      });
    }
  }
};
</script>
<style type="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/EplNewTransaction.vue